import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { QrCodeIcon } from "@heroicons/react/24/solid";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { mainSelectedTab } from "../../atoms";
import SearchInput2 from "../../../../components/SearchInput2";
import { prodCodeToOfficeId } from "../atoms/atoms";

//import { prodCodeId } from "../../../CarrierAgreementMgmt/ProducerCode/atom";

const OfficeCarrierProducerCodeViewAll = ({ data }) => {
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  // for Search filter
  const [isSearchTextProdCode, setIsSearchTextProdCode] = useState(false);
  const [filteredCarrierProdCode, setCarrierfilteredCarrierProdCode] = useState(
    []
  );
  //const [, setProdCodeId] = useRecoilState(prodCodeId);
  const [searchInputField, setSearchInputField] = useState("");
  // for clear button
  const handleClearButton = () => {
    setIsSearchTextProdCode(false);
    handleSearchProdCode("");
    setSearchInputField("");
  };
  const [getProdCodeToOfficeId, setProdCodeToOfficeId] =
    useRecoilState(prodCodeToOfficeId);
  const handleSearchProdCode = (target) => {
    setCarrierfilteredCarrierProdCode(
      data?.filter(
        (pD) =>
          pD.carrierName
            ?.toString()
            ?.toLocaleLowerCase()
            ?.includes(target?.toLocaleLowerCase()?.toString()) ||
          pD.producerCodes
            ?.toString()
            ?.toLocaleLowerCase()
            ?.includes(target?.toLocaleLowerCase()?.toString())
      )
    );
  };
  return (
    <>
      <div className="w-full borderContainer p-2 bg-white px-9">
        <div className="py-2 grid grid-cols-6 gap-1">
          <div className="text-xs col-start-1 col-end-2 flex flex-row">
            <SearchInput2
              className="border-b"
              placeholder="Search"
              id="searchFilter"
              value={searchInputField}
              onChange={(e) => {
                setSearchInputField(e.target.value);
                handleSearchProdCode(e.target.value);
                e.target.value === ""
                  ? setIsSearchTextProdCode(false)
                  : setIsSearchTextProdCode(true);
              }}
            />
            <button
              className="opacity-50 -ml-3"
              onClick={() => handleClearButton()}
            >
              X
            </button>
          </div>
        </div>
        <div className="grid gap-2 grid-cols-5">
          {data &&
            !isSearchTextProdCode &&
            data?.map((x) => {
              const producerCode = x.producerCode ? x.producerCode : null;
              const mAproducerCode = x.mAproducerCode ? x.mAproducerCode : null;
              const codes = producerCode ?? mAproducerCode ?? "";
              return (
                <div className="bg-white border border-gray-200 w-full shadow-md rounded-md">
                  <div className="flex p-2">
                    <div className="translate-y-4">
                      <QrCodeIcon className="text-blue-500 h-8 w-8" />
                    </div>
                    <div className="text-gray-600 font-medium ml-2 truncate ">
                      <h3 className="text-xs1 flex items-center font-normal text-gray-400">
                        <svg
                          className={
                            x.isActive
                              ? "text-green-500 mr-1 talic h-2 w-2"
                              : "text-gray-40 mr-1 talic h-2 w-2"
                          }
                          fill="currentColor"
                          viewBox="0 0 8 8"
                        >
                          <circle
                            cx={4}
                            cy={4}
                            r={3}
                            // className={
                            //   x.isActive ? "text-green-500  " : "text-gray-40 "
                            // }
                          />
                        </svg>{" "}
                        {x.isActive ? "Active" : "Inactive"}
                      </h3>
                      <h1
                        className="tileClasses"
                        onClick={() => {
                          const url =
                            "/carrieragreementmgmt/producercodeconfig";
                          history.push({
                            pathname: url,
                            state: {
                              masterCarrierId: x.masterCarrierID,
                              carrierProducerCodeId: x.carrierProducerCodeId,
                              action: "CarrierProducerCode",
                              officeId: getProdCodeToOfficeId,
                            },
                          });

                          window.location.reload();
                        }}
                      >
                        {codes}
                      </h1>
                      {!x.producerCode && (
                        <h2 className="text-xxs font-medium text-gray-400">
                          {"MA Codes"}
                        </h2>
                      )}
                      <h2 className="text-xs font-medium text-gray-700 mt-1">
                        {x.carrierName ? x.carrierName : "unspecified"}
                      </h2>
                      <h2 className="text-xxs font-medium text-gray-400">
                        {x.associatedTo ? x.associatedTo : "unspecified"}
                      </h2>
                    </div>
                  </div>
                </div>
              );
            })}
          {isSearchTextProdCode &&
            filteredCarrierProdCode?.map((x) => {
              const producerCode = x.producerCode ? x.producerCode : null;
              const mAproducerCode = x.mAproducerCode ? x.mAproducerCode : null;
              const codes = producerCode ?? mAproducerCode ?? "";
              return (
                <div className="bg-white border border-gray-200 w-full shadow-md rounded-md">
                  <div className="flex p-2">
                    <div className="translate-y-4">
                      <QrCodeIcon className="text-blue-500 h-8 w-8" />
                    </div>
                    <div className="text-gray-600 font-medium ml-2 truncate  ">
                      <h3 className="text-xs1 flex items-center font-normal text-gray-400">
                        <svg
                          className={
                            x.isActive
                              ? "text-green-500 mr-1 talic h-2 w-2"
                              : "text-gray-40 mr-1 talic h-2 w-2"
                          }
                          fill="currentColor"
                          viewBox="0 0 8 8"
                        >
                          <circle
                            cx={4}
                            cy={4}
                            r={3}
                            // className={
                            //   x.isActive ? "text-green-500  " : "text-gray-40 "
                            // }
                          />
                        </svg>{" "}
                        {x.isActive ? "Active" : "Inactive"}
                      </h3>
                      <h1
                        className="tileClasses"
                        onClick={() => {
                          const url =
                            "/carrieragreementmgmt/producercodeconfig";
                          history.push({
                            pathname: `/carrieragreementmgmt/producercodeconfig?actionFrom=CarrierProducerCode&masterCarrierId=${x.masterCarrierID}&carrierProducerCodeId=${x.carrierProducerCodeId}`,
                          });
                          let userTabs = [
                            {
                              to: "",
                            },
                          ];
                          [...CarrierAgreementMgmtTabs].forEach((tabs) => {
                            let temp = [...userPermissions].filter(
                              (user) => user === tabs.permission
                            );
                            if (temp.length > 0)
                              userTabs.push({
                                to: tabs.to,
                              });
                          });
                          userTabs.shift();
                          const index = userTabs.findIndex((c) => c.to === url);
                          setSelectedIndex(index);
                        }}
                      >
                        {codes}
                      </h1>
                      {!x.producerCode && (
                        <h2 className="text-xxs font-medium text-gray-400">
                          {"MA Codes"}
                        </h2>
                      )}
                      <h2 className="text-xs font-medium text-gray-700 mt-1">
                        {x.carrierName ? x.carrierName : "unspecified"}
                      </h2>
                      <h2 className="text-xxs font-medium text-gray-400">
                        {x.associatedTo ? x.associatedTo : "unspecified"}
                      </h2>
                    </div>
                  </div>
                </div>
              );
            })}
          {isSearchTextProdCode && filteredCarrierProdCode.length === 0 && (
            <div className="flex pt-2 pb-5 items-center justify-center text-sm col-span-5">
              No records to display
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default OfficeCarrierProducerCodeViewAll;
